//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { elementType, format } from "@/views/stencil/common/config";
import elementInput from "@/views/stencil/components/from/fromInput";
import FormItem from "@/components/common/from/fromItem";

export default {
  data() {
    return {
      data: {}, // 绑定的数据
      fromPageData: {},
      key: 1,
    };
  },
  components: {
    elementInput,
    FormItem,
  },
  props: {
    modules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    schemes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    itemOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasTailModules: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    data: {
      deep: true,
      handler(newValue, oldValue) {
        let _this = this;
        // 过滤掉自定义的只读项
        let fromPageData = {};
        Object.keys(newValue).forEach((key) => {
          if (key.indexOf("ZDY") == -1) {
            fromPageData[key] = newValue[key];
          }
        });
        this.fromPageData = fromPageData;
        this.$emit("change", { allFromData: newValue, fromPageData });
      },
    },
    modules: {
      deep: true,
      handler(newValue, oldValue) {
        this.key += 1;
        /**
         * 同步data - 解决问题场景
         * modules更新情况下，前一次modules的元素大于此次modules的元素
         * 需要删除多余的字段
         */
        if (Array.isArray(newValue)) {
          const elementEnumsOfAllModules = newValue.reduce(
            (allKeys, moduleItem) => {
              if (Array.isArray(moduleItem.elements)) {
                moduleItem.elements.forEach((element) => {
                  allKeys.push(element.elementEnums);
                });
              }
              return allKeys;
            },
            []
          );
          Object.keys(this.data).forEach(dataKey => {
            if (elementEnumsOfAllModules.indexOf(dataKey) < 0) {
              delete this.data[dataKey]
            }
          });
        }
      },
    },
  },
  methods: {
    TypeCode(code) {
      return elementType[code] || "elementInput";
    },
    // 得到的参数格式化
    setElement(element, code) {
      return format(element, code);
    },
    // 数据手动修改时
    itemChange(item) {
      // 目前赠险保费不会根据投保人信息改变 ，所以先注释
      // this.$nextTick(()=>{
      //   // 如果是算费因子去取请求算费结果
      //   if(item.isCount){
      //     this.$nextTick(()=>{
      //       // 调用公共方法请求算费
      //         this.getRateResult(this.fromPageData,this.allData.productCode).then(res =>{
      //             // 设置价格
      //             let item = this.data['ZDY002']
      //             item.value = '￥' + res.price;
      //             this.$set(this.data,'ZDY002',item);
      //         })
      //     })
      //   }

      // })
      this.$emit("itemChange", item);
    },
    schemeLayerShow(item) {
      this.$emit("schemeLayerShow", item);
    },
  },
};
